import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { get } from 'lodash';

import Button from '../../../material-ui-kit/CustomButtons/Button';
import useStyles from './TemplateActionsStyle';
import { ActionsTemplateValues } from './TemplateTextConsts';
import EmployerContext from '../../../../contexts/EmployerContext';
import PositionContext from '../../../../contexts/PositionContext';

const TemplateAction = (props) => {
    const {
        onRemove,
        isActionButtonDisabled,
    } = props;

    const classes = useStyles();
    const { t } = useTranslation();
    const { positionId } = useContext(PositionContext);
    const { employer } = useContext(EmployerContext);

    const isNewLandingPageEnabled = get(employer, 'settings.isNewLandingPageEnabled');

    const openPositionDescriptionPage = () => {
        if (positionId && !isActionButtonDisabled) {
            const positionDescriptionRouteVersion = isNewLandingPageEnabled ? 'position-description-v2' : 'position-description';
            window.open(`/public/${positionDescriptionRouteVersion}/${positionId}?showDisabledForm=true`, '_blank');
        }
    };

    const feedbackButtons = <div className={classes.container}>
        <Button
            href={'url'} color='primary'
            testId={'position-approval-button'}
            style={{ marginRight: 8 }}
            className={classes.linkButton}
            onClick={openPositionDescriptionPage}
        >
            {t('PUBLIC_JOB_DESCRIPTION_JOB_FORM_APPROVE_LABEL')}
        </Button>

        <Button
            href={'test'}
            testId={'position-reject-button'}
            color='secondary'
            className={classes.linkButton}
            onClick={openPositionDescriptionPage}
        >
            {t('PUBLIC_JOB_DESCRIPTION_JOB_FORM_REJECT_LABEL')}
        </Button>

        <FontAwesomeIcon
            className={classes.icon}
            icon='times'
            data-test-id='template-text-remove-button'
            onFocus={(e) => e.stopPropagation()}
            onClick={(e) => {
                e.stopPropagation();
                onRemove(props);
            }}
        />
    </div>;

    const alreadyAppliedButton = <div className={classes.container}>
        <Button
            href={'url'} color='primary'
            testId={'position-approval-button'}
            style={{ marginRight: 8 }}
            className={classes.linkButton}
        >
            {t('ALREADY_APPLIED', 'Already Applied')}
        </Button>

        <FontAwesomeIcon
            className={classes.icon}
            icon='times'
            data-test-id='template-text-remove-button'
            onFocus={(e) => e.stopPropagation()}
            onClick={(e) => {
                e.stopPropagation();
                onRemove(props);
            }}
        />
    </div>;

    const findOutMoreButton = <div className={classes.container}>
        <Button
            href={'url'} color='primary'
            testId={'position-approval-button'}
            style={{ marginRight: 8 }}
            className={classes.linkButton}
            onClick={openPositionDescriptionPage}
        >
            {t('FIND_OUT_MORE', 'Find Out More')}
        </Button>

        <FontAwesomeIcon
            className={classes.icon}
            icon='times'
            data-test-id='template-text-remove-button'
            onFocus={(e) => e.stopPropagation()}
            onClick={(e) => {
                e.stopPropagation();
                onRemove(props);
            }}
        />
    </div>;

    const notInterestedButton = <div className={classes.container}>
        <Button
            href={'test'}
            testId={'position-reject-button'}
            color='secondary'
            className={classes.linkButton}
            onClick={openPositionDescriptionPage}
        >
            {t('PUBLIC_JOB_DESCRIPTION_JOB_FORM_REJECT_LABEL')}
        </Button>

        <FontAwesomeIcon
            className={classes.icon}
            icon='times'
            data-test-id='template-text-remove-button'
            onFocus={(e) => e.stopPropagation()}
            onClick={(e) => {
                e.stopPropagation();
                onRemove(props);
            }}
        />
    </div>;

    const giveFeedbackButton = <div className={classes.container}>
        <Button
            href={'url'} color='primary'
            testId={'position-approval-button'}
            style={{ marginRight: 8 }}
            className={classes.linkButton}
        >
            {t('GIVE_FEEDBACK_BUTTON_LABEL', 'Give Feedback')}
        </Button>

        <FontAwesomeIcon
            className={classes.icon}
            icon='times'
            data-test-id='template-text-remove-button'
            onFocus={(e) => e.stopPropagation()}
            onClick={(e) => {
                e.stopPropagation();
                onRemove(props);
            }}
        />
    </div>;

    const rateProfilesButton = <div className={classes.container}>
        <Button
            href={'url'} color='primary'
            testId={'position-approval-button'}
            style={{ marginRight: 8 }}
            className={classes.linkButton}
        >
            {t('RATE_PROFILES_BTN_LABEL', 'Rate Profiles')}
        </Button>

        <FontAwesomeIcon
            className={classes.icon}
            icon='times'
            data-test-id='template-text-remove-button'
            onFocus={(e) => e.stopPropagation()}
            onClick={(e) => {
                e.stopPropagation();
                onRemove(props);
            }}
        />
    </div>;

    const autoText = props?.decoratedText;

    let result;
    switch (autoText) {
        case props.openTemplateTextChar + ActionsTemplateValues.alreadyAppliedButton + props.closeTemplateTextChar:
            result = alreadyAppliedButton;
            break;
        case props.openTemplateTextChar + ActionsTemplateValues.findOutMoreButton + props.closeTemplateTextChar:
            result = findOutMoreButton;
            break;
        case props.openTemplateTextChar + ActionsTemplateValues.notInterestedButton + props.closeTemplateTextChar:
            result = notInterestedButton;
            break;
        case props.openTemplateTextChar + ActionsTemplateValues.giveFeedbackButton + props.closeTemplateTextChar:
            result = giveFeedbackButton;
            break;
        case props.openTemplateTextChar + ActionsTemplateValues.rateProfilesButton + props.closeTemplateTextChar:
            result = rateProfilesButton;
            break;
        default:
            result = feedbackButtons;
    }

    return result;
};

TemplateAction.defaulProps = {
    templateTextContextData: {},
    onRemove: () => {},
};

TemplateAction.propTypes = {
    openTemplateTextChar: PropTypes.string,
    closeTemplateTextChar: PropTypes.string,
    templateTextOptions: PropTypes.array,
    templateTextContextData: PropTypes.object,
    onRemove: PropTypes.func,
    decoratedText: PropTypes.string,
};

export default memo(TemplateAction);
